module.exports = __webpack_public_path__ + "blanket_product_04_large@2x.png?4364dcd30a1af32464720af5b6839460";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blanket_product_04_large@2x.png
// module id = 663
// module chunks = 0